import React from 'react';
import { Alert, Box, Grid } from '@mui/material';

import { getProductGroupAlertSeverity, getSurveySuggestion } from './utils';
import { productGroupAlerts } from './constants';

import { WalletFormValues } from '../types';
import { walletFormFields } from '../components/walletFormFields';

interface WalletFormContentProps {
  values: Partial<WalletFormValues>;
}

export const WalletFormContent: React.FC<WalletFormContentProps> = ({ values }) => {
  const productGroupCount = values.productGroup?.values.length;

  const productGroupAlertSeverity = productGroupCount
    ? getProductGroupAlertSeverity(productGroupCount)
    : null;

  const surveySuggestion = getSurveySuggestion(values);

  return (
    <Grid container spacing={3}>
      <walletFormFields.Name />

      {/* Wallet Name field should be the only component in the first row. This Box takes up all remaining space. */}
      <Box width='100%' />

      <walletFormFields.WalletConfiguration />

      {values.productGroup && productGroupAlertSeverity && productGroupCount && (
        <Grid container item md={12} spacing={3}>
          <Grid item md={6}>
            <Alert
              severity={productGroupAlertSeverity}
              sx={{
                '& .MuiAlert-icon': {
                  marginTop: 'auto',
                  marginBottom: 'auto',
                },
              }}
            >
              {productGroupAlerts[productGroupAlertSeverity](productGroupCount)}
            </Alert>
          </Grid>
        </Grid>
      )}

      <walletFormFields.SurveyQuestion />
      <walletFormFields.Range />

      {surveySuggestion && (
        <Grid item md={6}>
          <Alert
            severity='info'
            sx={{
              '& .MuiAlert-icon': {
                marginTop: 'auto',
                marginBottom: 'auto',
              },
            }}
          >
            {`Keep it short and simple. We suggest: "${surveySuggestion}"`}
          </Alert>
        </Grid>
      )}

      <walletFormFields.IncentivizeResponses values={values} />
    </Grid>
  );
};
